import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import logo from "./logo.svg";
import filter from "./filter.svg";
import menu from "./menu.svg";
import user_cv from "./user_cv.svg";
import add_job from "./add_job.svg";
import admin from "./admin.svg";
import logout from "./logout.svg";
import "./App.css";
import Job from "./components/Job"; // Import Job component
import JobApply from "./components/JobApply";
import ThankYou from "./components/ThankYou";
import Welcome from "./components/Welcome";
import CreateJob from "./components/CreateJob";
import CV from "./components/CV";
const client_id = process.env.REACT_APP_CLIENT_ID;
const api_endpoint = process.env.REACT_APP_API_ENDPOINT;
function App() {
  const [user, setUser] = useState(null);
  const [userPicture, setUserPicture] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [formData, setFormData] = useState({ name: "", email: "" });
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [applyJobId, setApplyJobId] = useState(null);
  const [showThankYou, setShowThankYou] = useState(false);
  const [showWelcome, setShowWelcome] = useState(true);
  const [createJob, setCreateJob] = useState(false);
  const [createCV, setCreateCV] = useState(false);
  const location = useLocation();
  const [desktopView] = useState(window.innerWidth > 1200);
  const fetchJobInputs = async () => {
    try {
      const response = await fetch(api_endpoint + "/api/inputs");
      const fetchedData = await response.json();

      // Initialize all fields with "selected" field
      const initializeSelection = (items) =>
        items.map((item) => ({ ...item, selected: 0 }));

      setLicenseTypes(initializeSelection(fetchedData.license_type));
      setAdditionalLicenses(
        initializeSelection(fetchedData.additional_licenses)
      );
      setPlaceOfWork(initializeSelection(fetchedData.place_of_work));
      setEmploymentType(initializeSelection(fetchedData.employment_type));
      setSalaryDuration(initializeSelection(fetchedData.salary_duration));
      setLanguage(initializeSelection(fetchedData.language));
      setTrailerType(initializeSelection(fetchedData.trailer_type));
      setVehicle(initializeSelection(fetchedData.vehicle));
      setJobType(initializeSelection(fetchedData.job_type));
      setPav(initializeSelection(fetchedData.pav));
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };
  useEffect(() => {
    fetchJobInputs();
  }, []);
  const [filters, setFilters] = useState([]);
  const handleFilterChange = (stateSetter, currentState, id) => {
    stateSetter(
      currentState.map((item) =>
        item.id === id
          ? { ...item, selected: item.selected === 0 ? 1 : 0 }
          : item
      )
    );

    const newFilters = filters.includes(id)
    ? filters.filter(filterId => filterId !== id)
    : [...filters, id];

  setFilters(newFilters);
  };

  const resetAllFilters = async () => {
        setFilters([]);
        fetchJobInputs();
  };

  const [licenseTypes, setLicenseTypes] = useState([]);
  const [additionalLicenses, setAdditionalLicenses] = useState([]);
  const [placeOfWork, setPlaceOfWork] = useState([]);
  const [employmentType, setEmploymentType] = useState([]);
  const [salaryDuration, setSalaryDuration] = useState([]);
  const [language, setLanguage] = useState([]);
  const [trailerType, setTrailerType] = useState([]);
  const [vehicle, setVehicle] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [pav, setPav] = useState([]);
  useEffect(() => {
    fetchJobs();
  }, [filters]);
  useEffect(() => {
    const match = location.pathname.match(/\/job\/(\d+)/);
    if (match) {
      setSelectedJobId(match[1]);
    }
  }, [location.pathname]);
  useEffect(() => {
    let timer;

    const setupTimeout = () => {
      timer = setTimeout(() => {
        setShowWelcome(false);
      }, 3000);
    };

    setupTimeout();

    return () => clearTimeout(timer);
  }, []);
  const onSuccess = async (res) => {
    const decodedUser = jwtDecode(res.credential);
    localStorage.setItem("user", JSON.stringify(decodedUser));

    setUser(decodedUser);
    setUserPicture(decodedUser.picture);
    try {
      const response = await fetch(api_endpoint + "/api/users", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "google-id": decodedUser.sub,
          name: decodedUser.name,
          email: decodedUser.email,
        },
      });

      // Parse response as JSON
      const data = await response.json();
      console.log("Server response:", data);

      if (data.user) {
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("picture", JSON.stringify(decodedUser.picture));
        setUser(data.user);
      }
    } catch (error) {
      console.error("Error inserting user:", error);
    }

    setIsMenuOpen(false);
  };

  const closeFilterAndMenu = () => {
    setIsMenuOpen(false);
    setIsFilterOpen(false);
  };
  const clearEverything = () => {
    setIsMenuOpen(false);
    setIsFilterOpen(false);
    setSelectedJobId(null);
    setApplyJobId(null);
    setCreateCV(null);
    setCreateJob(null);
  };
  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    setUserPicture(null);
    closeFilterAndMenu();
  };
  const handleNameOrEmailChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleApply = async () => {
    // Check if form fields are filled
    if (!formData.name || !formData.email) {
      alert("Kérjük töltse ki a mindkét mezőt!");
      return; // Exit the function if fields are empty
    }

    try {
      const response = await fetch(
        api_endpoint + "/api/jobs/" + applyJobId + "/applications",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            jobId: selectedJobId,
          }),
        }
      );

      if (!response.ok) {
        console.log(response);
        alert("Sikertelen jelentkezés " + response.message);
      }

      const data = await response.json();
      setSelectedJobId(null);
      setApplyJobId(null);
      setFormData({ name: "", email: "" });
      setShowThankYou(true);
      setTimeout(() => {
        setShowThankYou(false);
      }, 6000);
    } catch (error) {
      alert("Sikertelen jelentkezés " + error.message);
    }
  };
  const fetchJobs = async () => {
    try {
      const response = await fetch(api_endpoint + "/api/jobs", {
        method: "POST", 
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          filters: filters
        })
      });      
      const data = await response.json();

      // Map the response data to fit the format you want
      const formattedJobs = data.map((job) => ({
        id: job.id,
        companyLogo: job.logo, // You can use placeholder logos or get logos from the database
        companyName: job.company,
        companyLocation: job.location, // Set location as a placeholder for now
        jobTitle: job.name,
        requirements: job.requirements,
      }));

      setJobs(formattedJobs); // Set the formatted jobs into the state
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };

  useEffect(() => {
    // Load user data from localStorage when component mounts
    const storedUser = localStorage.getItem("user");
    const storedPicture = localStorage.getItem("picture");
    if (storedPicture) {
      const decodedPicture = JSON.parse(storedPicture);
      setUserPicture(decodedPicture);
    }
    if (storedUser) {
      if (
        storedUser.exp &&
        storedUser.exp - Math.floor(Date.now() / 1000) < 20
      ) {
        setUser(null);
        return;
      }
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);
    }
  }, []);
  useEffect(() => {
    if (user) {
      setFormData({ name: user.name, email: user.email });
    }
  }, [user]);
  return (
    <GoogleOAuthProvider clientId={client_id}>
      <div className="App">
        {!showThankYou && !showWelcome && (
          <header className="App-header">
            <div className="logo-container">
              {/* <img src={logo} className="App-logo" alt="logo" /> */}
              <h1 onClick={clearEverything} style={{cursor: 'pointer'}}>Kamionosallasok.com</h1>
            </div>

            {user && userPicture ? (
              <div style={{ marginRight: "10px", width: "100px" }}>
                <img
                  src={userPicture}
                  alt="profile"
                  className="profile-image"
                />
              </div>
            ) : null}

            {!user && desktopView ? (
              <div style={{ marginRight: "150px", width: "100px" }}>
                <GoogleLogin
                  onSuccess={onSuccess}
                  onError={(error) => console.log("Error:", error)}
                  theme="filled_blue"
                  shape="pill"
                  size="large"
                  logo_alignment="center"
                  width="40%"
                />
              </div>
            ) : null}
          </header>
        )}
        {createCV && <CV user={user} desktopView={desktopView} />}
        {createJob && <CreateJob user={user} desktopView={desktopView} />}
        {showThankYou && <ThankYou />}
        {showWelcome && <Welcome />}
        {selectedJobId && !applyJobId && (
          <>
            <Job jobId={selectedJobId} desktopView={desktopView}/>
            <div className={desktopView ? "footer-desktop" : "footer"}>
              <button
                className="back-button"
                onClick={() => setSelectedJobId(null)}
              >
                Vissza
              </button>
              <button
                className="apply-button"
                onClick={() => setApplyJobId(selectedJobId)}
              >
                Jelentkezés
              </button>
            </div>
          </>
        )}
        {selectedJobId && applyJobId && (
          <>
            <JobApply jobId={applyJobId} />
            <input
              className="input-field"
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleNameOrEmailChange}
              required
              autoFocus
              placeholder="Írja be a nevét"
            />
            <input
              className={`input-field`}
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleNameOrEmailChange}
              required
              placeholder="Írja be az e-mail címét"
            />
            <div className={desktopView ? "footer-desktop" : "footer"}>
              <button
                className="back-button"
                onClick={() => setApplyJobId(null)}
              >
                Vissza
              </button>
              <button className="apply-button" onClick={handleApply}>
                Véglegesítés
              </button>
            </div>
          </>
        )}
        {!selectedJobId &&
          !applyJobId &&
          !showThankYou &&
          !showWelcome &&
          !createJob &&
          !createCV && (
            <>
              <section className="second-header">
                {!desktopView && (
                  <>
                    <button
                      className="filter-button"
                      onClick={() => setIsFilterOpen(true)}
                    >
                      <img src={filter} className="Other-logo" alt="filter" />
                      <span className="button-text">Szűrő</span>{" "}
                      {/* Add text to the right */}
                    </button>
                    <button
                      className="menu-button"
                      onClick={() => setIsMenuOpen(true)}
                    >
                      <img src={menu} className="Other-logo" alt="menu" />
                      <span className="button-text">Menü</span>
                    </button>
                  </>
                )}

                {desktopView && (
                  <>
                    {user && user.type == "admin" && (
                      <button
                        className="menu-button"
                        onClick={closeFilterAndMenu}
                      >
                        <img src={admin} className="Other-logo" alt="menu" />
                        <span className="button-text">
                          Admin oldal megnyitása
                        </span>
                      </button>
                    )}
                        <button
                          className="menu-button"
                          onClick={() => setCreateJob(true)}
                        >
                          <img
                            src={add_job}
                            className="Other-logo"
                            alt="menu"
                          />
                          <span className="button-text">
                            Álláshirdetés feladása
                          </span>
                        </button>
                    {user && (user.type == null || user.type == "admin") && (
                      <button
                        className="menu-button"
                        onClick={() => setCreateCV(true)}
                      >
                        <img src={user_cv} className="Other-logo" alt="menu" />
                        <span className="button-text">
                          {" "}
                          Önéletrajz szerkesztése
                        </span>
                      </button>
                    )}
                    {user && (
                      <button className="menu-button" onClick={handleLogout}>
                        <img src={logout} className="Other-logo" alt="menu" />
                        <span className="button-text"> Kilépés</span>
                      </button>
                    )}
                  </>
                )}
              </section>

              {isMenuOpen && (
                <div className="menu-overlay">
                  {user && user.type == "admin" && (
                    <button
                      className="custom-button"
                      onClick={closeFilterAndMenu}
                    >
                      Admin oldal megnyitása
                    </button>
                  )}
                  {user && (user.type == "admin" || user.type == "poster") && (
                    <button
                      className="custom-button"
                      onClick={() => setCreateJob(true)}
                    >
                      Álláshirdetés feladás
                    </button>
                  )}
                  {user && (user.type == null || user.type == "admin") && (
                    <button
                      className="custom-button"
                      onClick={() => setCreateCV(true)}
                    >
                      Önéletrajz szerkesztése
                    </button>
                  )}
                  <button
                    className="custom-button"
                    onClick={closeFilterAndMenu}
                  >
                    Bezárás
                  </button>
                  <br></br> <br></br> <br></br>
                  {!user && !desktopView && (
                    <GoogleLogin
                      onSuccess={onSuccess}
                      onError={(error) => console.log("Error:", error)}
                      theme="filled_blue" // You can change the theme
                      shape="pill" // Pill shape for a rounded button
                      size="large"
                      logo_alignment="center"
                      width="40%"
                    />
                  )}
                  {user && (
                    <button className="custom-button" onClick={handleLogout}>
                      Kilépés
                    </button>
                  )}
                </div>
              )}
              {/* majd ha meg leszn desktop telefon különböztetve akkor emnu overlay -m vagy nem -m */}
              {(isFilterOpen || desktopView) && (
                <div
                  className={
                    desktopView ? "menu-overlay-desktop" : "menu-overlay"
                  }
                >
                  
                  <div class="inner-scroll-container">
                  <h3 onClick={resetAllFilters}>Szűrők  <div style={{color:'red'}}>{ filters.length > 0 ? 'X' : ''} </div></h3>
                    <div className="input-group">
                      <div className="multiselect">
                        <h3>Jogosítvány</h3>
                        {licenseTypes.map((item) => (
                          <div
                            key={item.id}
                            className={`multiselect-item-filter ${
                              item.selected === 1
                                ? "selected-orange-filter"
                                : ""
                            }`}
                            onClick={() =>
                              handleFilterChange(
                                setLicenseTypes,
                                licenseTypes,
                                item.id
                              )
                            }
                          >
                            <span
                              style={{ color:"black" }}
                            >
                              {item.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="input-group">
                      <div className="multiselect">
                        <h3>Jármű</h3>
                        {vehicle.map((item) => (
                          <div
                            key={item.id}
                            className={`multiselect-item-filter ${
                              item.selected === 1
                                ? "selected-orange-filter"
                                : ""
                            }`}
                            onClick={() =>
                              handleFilterChange(
                                setVehicle,
                                vehicle,
                                item.id
                              )
                            }
                          >
                            <span
                              style={{ color:"black" }}
                            >
                              {item.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="input-group">
                      <div className="multiselect">
                        <h3>Egyéb képesítések</h3>
                        {additionalLicenses.map((item) => (
                          <div
                            key={item.id}
                            className={`multiselect-item-filter ${
                              item.selected === 1
                                ? "selected-orange-filter"
                                : ""
                            }`}
                            onClick={() =>
                              handleFilterChange(
                                setAdditionalLicenses,
                                additionalLicenses,
                                item.id
                              )
                            }
                          >
                            <span
                              style={{ color:"black" }}
                            >
                              {item.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="input-group">
                      <div className="multiselect">
                        <h3>PAV</h3>
                        {pav.map((item) => (
                          <div
                            key={item.id}
                            className={`multiselect-item-filter ${
                              item.selected === 1
                                ? "selected-orange-filter"
                                : ""
                            }`}
                            onClick={() =>
                              handleFilterChange(setPav, pav, item.id)
                            }
                          >
                            <span
                              style={{ color:"black" }}
                            >
                              {item.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="input-group">
                      <div className="multiselect">
                        <h3>Beszélt nyelvek</h3>
                        {language.map((item) => (
                          <div
                            key={item.id}
                            className={`multiselect-item-filter ${
                              item.selected === 1
                                ? "selected-orange-filter"
                                : ""
                            }`}
                            onClick={() =>
                              handleFilterChange(
                                setLanguage,
                                language,
                                item.id
                              )
                            }
                          >
                            <span
                              style={{ color:"black" }}
                            >
                              {item.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="input-group">
                      <div className="multiselect">
                        <h3>Munkavégzés preferált helye</h3>
                        {placeOfWork.map((item) => (
                          <div
                            key={item.id}
                            className={`multiselect-item-filter ${
                              item.selected === 1
                                ? "selected-orange-filter"
                                : ""
                            }`}
                            onClick={() =>
                              handleFilterChange(
                                setPlaceOfWork,
                                placeOfWork,
                                item.id
                              )
                            }
                          >
                            <span
                              style={{ color:"black" }}
                            >
                              {item.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="input-group">
                      <div className="multiselect">
                        <h3>Munkavállalás típusa</h3>
                        {employmentType.map((item) => (
                          <div
                            key={item.id}
                            className={`multiselect-item-filter ${
                              item.selected === 1
                                ? "selected-orange-filter"
                                : ""
                            }`}
                            onClick={() =>
                              handleFilterChange(
                                setEmploymentType,
                                employmentType,
                                item.id
                              )
                            }
                          >
                            <span
                              style={{ color:"black" }}
                            >
                              {item.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="input-group">
                      <div className="multiselect">
                        <h3>Fizetési frekvencia</h3>
                        {salaryDuration.map((item) => (
                          <div
                            key={item.id}
                            className={`multiselect-item-filter ${
                              item.selected === 1
                                ? "selected-orange-filter"
                                : ""
                            }`}
                            onClick={() =>
                              handleFilterChange(
                                setSalaryDuration,
                                salaryDuration,
                                item.id
                              )
                            }
                          >
                            <span
                              style={{ color:"black" }}
                            >
                              {item.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="input-group">
                      <div className="multiselect">
                        <h3>Tréler</h3>
                        {trailerType.map((item) => (
                          <div
                            key={item.id}
                            className={`multiselect-item-filter ${
                              item.selected === 1
                                ? "selected-orange-filter"
                                : ""
                            }`}
                            onClick={() =>
                              handleFilterChange(
                                setTrailerType,
                                trailerType,
                                item.id
                              )
                            }
                          >
                            <span
                              style={{ color:"black" }}
                            >
                              {item.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="input-group">
                      <div className="multiselect">
                        <h3>Munkatípus</h3>
                        {jobType.map((item) => (
                          <div
                            key={item.id}
                            className={`multiselect-item-filter ${
                              item.selected === 1
                                ? "selected-orange-filter"
                                : ""
                            }`}
                            onClick={() =>
                              handleFilterChange(
                                setJobType,
                                jobType,
                                item.id
                              )
                            }
                          >
                            <span
                              style={{ color:"black" }}
                            >
                              {item.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  {!desktopView && (
                    <button
                      className="custom-button"
                      onClick={closeFilterAndMenu}
                    >
                      Bezárás {"(" + jobs.length + " találat)"}
                    </button>
                  )}
                </div>
              )}
              {/* Jobs Section */}
              <div className="jobs-container">
                {jobs.map((job, index) => (
                  <div
                    className="job-container"
                    key={index}
                    onClick={() => setSelectedJobId(job.id)}
                  >
                    <div className="company-info">
                      <img
                        src={job.companyLogo}
                        alt={`${job.companyName} logo`}
                        className="company-logo"
                      />
                      <p>{job.companyName}</p>
                      <p>{job.companyLocation}</p>
                    </div>
                    <div className="job-details">
                      <h3>{job.jobTitle}</h3>
                      <div className="job-chips">
                        {job.requirements &&
                          job.requirements.map((requirement, reqIndex) => (
                            <span key={reqIndex} className="chip">
                              {requirement.name}
                            </span>
                          ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
      </div>
    </GoogleOAuthProvider>
  );
}

export default App;
